import { useState } from 'react';

export const useExpandableText = (fullText, words = 150) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const truncatedText = fullText?.slice(0, words) + (fullText?.length > words ? '...' : '');

  const displayText = isExpanded ? fullText : truncatedText;

  return { displayText, isExpanded, toggleExpand };
};